module.exports = __webpack_public_path__ + "static/media/image_14.21bb8c99.png";